import React from 'react'
import { Line } from 'react-chartjs-2'
import ErrorBoundary from '../../../../components/Common/ErrorBoundary';

const LineChart = ({isDarkTheme,LineWidgetDetails, widgetConfig, handleModalShow}) => {

    const { title, dataset, labels, dataPoints, label, borderColor,tension} = LineWidgetDetails;
    const { WidgetName = 'Line Chart', WidgetID = ''} = widgetConfig || {}

    const data = {
        labels: labels,
        datasets: [{
        label: label,
        data: dataPoints,
        fill: false,
        borderColor: borderColor,
        tension: tension
        }]
    };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          color: isDarkTheme ? '#e6e6e6' : '#bababa',
        }
      }
    },
    onClick: (event, elements, chart) => {
      if (elements && elements.length > 0 && data) {
        const element = elements[0];
        const index = element.index;
        handleModalShow && handleModalShow({
          label: data.labels[index],
          value: data.datasets[0].data[index],
          index
        });
      }
    },
    onHover: (event, elements) => {
      if (event?.native) {
        event.native.target.style.cursor = elements && elements.length > 0 ? 'pointer' : 'default';
      }
    }
  };
 
   return (
    <ErrorBoundary>
      <div className='systemHealth m-0 WidgetPadding p-0' key={`widget-${WidgetID}`}>
         <p className='chartHeaderP p-2'>{WidgetName}</p>
         <div style={{ height: '86%',display:"flex", justifyContent:"center" }}>
             <Line options={options} data={data}/>
         </div>
     </div>
     </ErrorBoundary>
   )
}

export default LineChart